<div class="container-scroller content-wrapper">
  <div class="d-flex col-lg-11 mx-auto central-main mt-2">
    <img class="header-logo cursor-pointer" routerLink="/home" src="assets/svg/logo.svg" alt="header logo">
  </div>
  <div class="container-fluid page-body-wrapper full-page-wrapper">
    <div class="content-wrapper d-flex align-items-center auth px-0">
      <div class="row w-100 mx-0">
        <div class="mx-auto">
          @if (successMessage) {
            <div class="success-alert-container">
              <div
                class="min_media alert alert-success d-flex alert-dismissible fade show mb-6 successMessage">
                <img src="assets/svg/successIconAlert.svg" alt="Success Icon" class="me-2 image-distance">
                <span class="success-alert">{{ 'registration_content.verify_message' | translate }}</span>
              </div>
            </div>
          }
          @if (isError) {
            <div
              class="min_media alert alert-success d-flex align-items-center alert-dismissible fade show mb-6 verification-error-code">
              <svg width="24" height="24" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
                <mask id="mask0_3592_18678" style="mask-type:alpha" maskUnits="userSpaceOnUse" x="0" y="0" width="24"
                      height="24">
                  <rect width="24" height="24" fill="#D9D9D9"/>
                </mask>
                <g mask="url(#mask0_3592_18678)">
                  <path
                    d="M12 17C12.2833 17 12.5208 16.9042 12.7125 16.7125C12.9042 16.5208 13 16.2833 13 16C13 15.7167 12.9042 15.4792 12.7125 15.2875C12.5208 15.0958 12.2833 15 12 15C11.7167 15 11.4792 15.0958 11.2875 15.2875C11.0958 15.4792 11 15.7167 11 16C11 16.2833 11.0958 16.5208 11.2875 16.7125C11.4792 16.9042 11.7167 17 12 17ZM11 13H13V7H11V13ZM12 22C10.6167 22 9.31667 21.7375 8.1 21.2125C6.88333 20.6875 5.825 19.975 4.925 19.075C4.025 18.175 3.3125 17.1167 2.7875 15.9C2.2625 14.6833 2 13.3833 2 12C2 10.6167 2.2625 9.31667 2.7875 8.1C3.3125 6.88333 4.025 5.825 4.925 4.925C5.825 4.025 6.88333 3.3125 8.1 2.7875C9.31667 2.2625 10.6167 2 12 2C13.3833 2 14.6833 2.2625 15.9 2.7875C17.1167 3.3125 18.175 4.025 19.075 4.925C19.975 5.825 20.6875 6.88333 21.2125 8.1C21.7375 9.31667 22 10.6167 22 12C22 13.3833 21.7375 14.6833 21.2125 15.9C20.6875 17.1167 19.975 18.175 19.075 19.075C18.175 19.975 17.1167 20.6875 15.9 21.2125C14.6833 21.7375 13.3833 22 12 22Z"
                    fill="#D22627"/>
                </g>
              </svg>
              <div class="verification-error-code-text">{{ verificationErrorMessage }}</div>
            </div>
          }
          <div class="auth-form-light text-left">
            <h2
              class="text-center create-account-title create-account">{{ 'registration_content.create_account' | translate }}</h2>
            <form [formGroup]="registrationForm" (ngSubmit)="register()"
                  (keydown.enter)="$event.preventDefault(); registrationButton.focus(); registrationButton.click()"
                  method="post" class="pt-3 form-style-change">
              <div class="form-group d-flex">
                <div class="mr-2 flex-fill me-3">
                  <input formControlName="name" type="text" id="name"
                         placeholder="{{'registration_content.name' | translate}}*"
                         class="form-control form-control-lg password-reduced-placeholder-width"
                         [ngClass]="{'has-error': registerFormControl['name'].invalid && registerFormControl['name'].touched}"
                         (input)="trimInputValue($event, SharedConstants.NAME)"/>
                  @if (registerFormControl['name'].invalid && registerFormControl['name'].touched) {
                    <div class="validation">
                      @if (registerFormControl['name'].errors?.['required'] || registerFormControl['name'].errors?.['whitespace']) {
                        <small>{{ 'registration_content.enter_name' | translate }}</small>
                      }
                      @if (registerFormControl['name'].errors?.['minlength'] || registerFormControl['name'].errors?.['maxlength']) {
                        <small>{{ 'registration_content.message' | translate }} {{ 'registration_content.characters' | translate }}</small>
                      }
                    </div>
                  }
                </div>
                <div class="ml-2 flex-fill">
                  <input formControlName="surname" type="text" id="surname"
                         placeholder="{{'registration_content.surname' | translate}}*"
                         class="form-control form-control-lg confirm-password-reduced-placeholder-width sur-top-fix"
                         [ngClass]="{'has-error': registerFormControl['surname'].invalid && registerFormControl['surname'].touched}"
                         (input)="trimInputValue($event, SharedConstants.SURNAME)"/>
                  @if (registerFormControl['surname'].invalid && registerFormControl['surname'].touched) {
                    <div class="validation">
                      @if (registerFormControl['surname'].errors?.['required'] || registerFormControl['surname'].errors?.['whitespace']) {
                        <small>{{ 'registration_content.enter_surname' | translate }}</small>
                      }
                      @if (registerFormControl['surname'].errors?.['minlength'] || registerFormControl['surname'].errors?.['maxlength']) {
                        <small>{{ 'registration_content.message' | translate }} {{ 'registration_content.characters' | translate }}</small>
                      }
                    </div>
                  }
                </div>
              </div>
              <div class="form-group">
                <input formControlName="email" type="email" id="email"
                       placeholder="{{'login_content.email' | translate}}*"
                       class="form-control form-control-lg email-simple-color confirm-password-reduced-placeholder-width"
                       [ngClass]="{'has-error': registerFormControl['email'].invalid && registerFormControl['email'].touched || errorMessage}"
                       (input)="resetErrorMessage()"/>
                @if (registerFormControl['email'].invalid && registerFormControl['email'].touched) {
                  <div class="validation">
                    @if (registerFormControl['email'].errors?.['required']) {
                      <small>{{ 'registration_content.enter_email' | translate }}</small>
                    }
                    @if (registerFormControl['email'].errors?.['pattern']) {
                      <small>{{ 'registration_content.valid_email' | translate }}</small>
                    }
                  </div>
                }
                @if (errorMessage) {
                  <div class="validation email-exists-error">
                    {{ errorMessage | translate }}
                  </div>
                }
              </div>
              <div class="form-group">
                <input formControlName="phoneNumber" type="tel" id="phone"
                       class="form-control form-control-lg confirm-password-reduced-placeholder-width form-tel"
                       placeholder="77 123456"
                       (keyup)="preventDefaultIfNotNumber($event)"
                       (keydown)="preventDefaultIfNotNumber($event)"
                       #phoneInput (blur)="validatePhoneNumber()"
                       [ngClass]="{'has-error': registerFormControl['phoneNumber'].invalid && registerFormControl['phoneNumber'].touched || registerFormControl['phoneNumber'].value !== '' && invalidPhoneNumberMessage}"/>
                @if (registerFormControl['phoneNumber'].invalid && registerFormControl['phoneNumber'].touched) {
                  <div class="validation">
                    @if (registerFormControl['phoneNumber'].errors?.['required']) {
                      <small>{{ 'registration_content.phone_number' | translate }}</small>
                    }
                  </div>
                }
                @if (invalidPhoneNumberMessage && registerFormControl['phoneNumber'].value !== '') {
                  <div class="validation">
                    <small>{{ invalidPhoneNumberMessage | translate }}</small>
                  </div>
                }
              </div>
              <div class="form-group">
                <div class="password-input-container">
                  <input formControlName="password" (input)="onInputSpaceChange($event, SharedConstants.PASSWORD)"
                         [type]="showPassword ? 'text' : 'password'" #passwordInput
                         placeholder="{{'login_content.password' | translate}}*"
                         class="form-control form-control-lg password-reduced-placeholder-width"
                         [ngClass]="{'has-error': registerFormControl['password'].invalid && registerFormControl['password'].touched}"/>
                  <span class="eye-icon">
                    <i class="bi" [ngClass]="{'bi-eye': showPassword, 'bi-eye-slash': !showPassword}"
                       (click)="togglePasswordVisibility('password')"></i>
                  </span>
                </div>
                @if (registerFormControl['password'].invalid && registerFormControl['password'].touched) {
                  <div class="validation">
                    @if (registerFormControl['password'].errors?.['required']) {
                      <small class="error-message">{{ 'registration_content.enter_password' | translate }}</small>
                    }
                    @if (registerFormControl['password'].errors?.['pattern']) {
                      <small>
                        @for (criteria of criteriaList; track criteria) {
                          <div class="box">
                            @if (isPasswordValid(criteria)) {
                              <svg width="24" height="24" viewBox="0 0 24 24" fill="none"
                                   xmlns="http://www.w3.org/2000/svg">
                                <mask id="mask0_3025_42178" style="mask-type:alpha" maskUnits="userSpaceOnUse" x="0"
                                      y="0" width="24" height="24">
                                  <rect width="24" height="24" fill="#D9D9D9"/>
                                </mask>
                                <g mask="url(#mask0_3025_42178)">
                                  <path
                                    d="M9.54986 14.6696L17.7705 6.4489C18.0364 6.18295 18.3517 6.04998 18.7162 6.04998C19.0807 6.04998 19.3959 6.18295 19.6618 6.4489C19.9278 6.71485 20.0607 7.03008 20.0607 7.39458C20.0607 7.75906 19.9278 8.07428 19.6618 8.34023L10.4901 17.512C10.2241 17.7779 9.91073 17.9109 9.54986 17.9109C9.18899 17.9109 8.87558 17.7779 8.60963 17.512L4.33788 13.2402C4.07195 12.9743 3.94079 12.6591 3.94441 12.2946C3.94803 11.9301 4.08281 11.6149 4.34876 11.3489C4.61471 11.083 4.92993 10.95 5.29443 10.95C5.65892 10.95 5.97413 11.083 6.24008 11.3489L9.54986 14.6696Z"
                                    fill="#1ED030"/>
                                </g>
                              </svg>
                            } @else {
                              <svg width="24" height="24" viewBox="0 0 24 24" fill="none"
                                   xmlns="http://www.w3.org/2000/svg">
                                <mask id="mask0_3025_42184" style="mask-type:alpha" maskUnits="userSpaceOnUse" x="0"
                                      y="0" width="24" height="24">
                                  <rect width="24" height="24" fill="#D9D9D9"/>
                                </mask>
                                <g mask="url(#mask0_3025_42184)">
                                  <path
                                    d="M11.9998 13.1665L6.86651 18.2998C6.70534 18.4609 6.51084 18.5415 6.28301 18.5415C6.05534 18.5415 5.86092 18.4609 5.69976 18.2998C5.53859 18.1386 5.45801 17.9442 5.45801 17.7165C5.45801 17.4887 5.53859 17.2942 5.69976 17.133L10.833 11.9998L5.69976 6.86651C5.53859 6.70534 5.45801 6.51084 5.45801 6.28301C5.45801 6.05534 5.53859 5.86092 5.69976 5.69976C5.86092 5.53859 6.05534 5.45801 6.28301 5.45801C6.51084 5.45801 6.70534 5.53859 6.86651 5.69976L11.9998 10.833L17.133 5.69976C17.2942 5.53859 17.4887 5.45801 17.7165 5.45801C17.9442 5.45801 18.1386 5.53859 18.2998 5.69976C18.4609 5.86092 18.5415 6.05534 18.5415 6.28301C18.5415 6.51084 18.4609 6.70534 18.2998 6.86651L13.1665 11.9998L18.2998 17.133C18.4609 17.2942 18.5415 17.4887 18.5415 17.7165C18.5415 17.9442 18.4609 18.1386 18.2998 18.2998C18.1386 18.4609 17.9442 18.5415 17.7165 18.5415C17.4887 18.5415 17.2942 18.4609 17.133 18.2998L11.9998 13.1665Z"
                                    fill="#D22627"/>
                                </g>
                              </svg>
                            }
                            <span class="text">{{ getCriteriaText(criteria) | translate }}</span>
                          </div>
                        }
                      </small>
                    }
                  </div>
                }
              </div>
              <div class="form-group">
                <div class="password-input-container">
                  <input formControlName="confirmPassword"
                         (input)="onInputSpaceChange($event, SharedConstants.CONFIRM_PASSWORD)"
                         [type]="showConfirmPassword ? 'text' : 'password'"
                         #confirmPasswordInput placeholder="{{'registration_content.confirm_password' | translate}}*"
                         class="form-control form-control-lg confirm-password-reduced-placeholder-width"
                         [ngClass]="{'has-error': registerFormControl['confirmPassword'].invalid && registerFormControl['confirmPassword'].touched || (registerFormControl['confirmPassword'].value !== '' && passwordMatchValidator(registrationForm))}"/>
                  <span class="eye-icon">
                    <i class="bi" [ngClass]="{'bi-eye': showConfirmPassword, 'bi-eye-slash': !showConfirmPassword}"
                       (click)="togglePasswordVisibility('confirmPassword')"></i>
                  </span>
                </div>
                @if (passwordMatchValidator(registrationForm) && registerFormControl['confirmPassword'].value !== '') {
                  <div class="validation">
                    <small>{{ 'registration_content.passwords_not_match' | translate }}</small>
                  </div>
                }
                @if (registerFormControl['confirmPassword'].touched && registerFormControl['confirmPassword'].hasError('required')) {
                  <div class="validation">
                    <small>{{ 'registration_content.confirm_password' | translate }}</small>
                  </div>
                }
              </div>
              <div class="form-group mt-3">
                <div class="d-flex align-items-start">
                  <input type="checkbox" formControlName="privacyPolicyAccepted" id="privacyPolicyAccepted"
                         class="me-2 mt-1" style="cursor: pointer; flex-shrink: 0;">
                  <label for="privacyPolicyAccepted" class="privacy-policy-label" style="cursor: pointer; font-size: 16px; line-height: 24px; color: #6B6C77;">
                    {{ 'registration_content.privacy_policy_acceptance_prefix' | translate }}
                    <a href="https://scanme.am/privacy-policy" target="_blank" rel="noopener noreferrer" class="privacy-policy-link">
                      {{ 'registration_content.privacy_policy' | translate }}
                    </a>
                    {{ 'registration_content.privacy_policy_acceptance_suffix' | translate }}
                  </label>
                </div>
                @if (registerFormControl['privacyPolicyAccepted'].invalid && registerFormControl['privacyPolicyAccepted'].touched) {
                  <div class="validation">
                    <small>{{ 'registration_content.privacy_policy_required' | translate }}</small>
                  </div>
                }
              </div>
              <div class="mt-3">
                <button type="submit" class="btn btn-block btn-primary btn-lg font-weight-medium auth-form-btn"
                        #registrationButton
                        [disabled]="isRegistrationClicked || isButtonDisabled">{{ 'login_content.sign_up' | translate }}
                </button>
              </div>
              <div class="text-center mt-4 font-weight-light question_title">
                {{ 'registration_content.already_have_account' | translate }}
                <button (click)="goToLogin()" class="btn-as-link ml-3px">
                  {{ 'login_content.login' | translate }}
                </button>
              </div>
            </form>
          </div>
        </div>
      </div>
    </div>
  </div>
</div>
